

exports.__esModule = true;

var _venmoModels = require('xo-venmo-components/src/venmo-models');

var _checkout = require('xo-models/src/checkout');

var _pxp = require('xo-page-components/src/cart/lib/pxp');

var _squid = require('squid');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-review-paywith-venmo',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                venmo: _venmoModels.$VenmoOnboardModel.instance(this.token).retrieve(),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.token).retrieve(),
                checkoutCart: _checkout.$CheckoutCartModel.instance(this.token).retrieve(),
                payee: _checkout.$CheckoutPayeeModel.instance(this.token).retrieve()
            };
        }
    },
    lifecycle: {
        populate: function populate() {

            var mapperFS = {
                BALANCE: function BALANCE(fs) {
                    return {
                        type: fs.funding_mode,
                        amount: getAmount()
                    };
                },
                PAYMENT_CARD: function PAYMENT_CARD(fs) {
                    return {
                        type: fs.funding_mode,
                        card_type: fs.payment_card.type,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.payment_card.type,
                        last4: fs.payment_card.number,
                        amount: getAmount()
                    };
                },
                BANK_ACCOUNT: function BANK_ACCOUNT(fs) {
                    return {
                        type: fs.funding_mode,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.bank_account.bank_name,
                        last4: fs.bank_account.account_number,
                        amount: getAmount()
                    };
                }
            };

            function determineShowAmt() {
                var userAction = models.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && models.checkoutCart.purchase.items.length === 0;

                return (0, _pxp.$pxpCartAmt)(models.checkoutAppData.merchant.merchant_country, models.payee.merchant.id, noLineItemDetails, models.checkoutCart.isPurchase()).then(function (showAmount) {
                    return models.checkoutCart.payment_action !== 'authorize' && showAmount;
                });
            }

            function getAmount() {
                return models.checkoutSession.plan.sources['0'].amount;
            }

            function getPlanList() {
                var defaultFS = models.venmo.funding_sources.default_option;

                if (defaultFS && defaultFS.funding_mode && mapperFS[defaultFS.funding_mode]) {
                    return [mapperFS[defaultFS.funding_mode](defaultFS)];
                } else {
                    return models.checkoutSession.plan.sources['0'];
                }
            }

            function getBackup() {
                var backup = models.venmo.funding_sources.alternate_option;

                if (backup && backup.funding_mode && mapperFS[backup.funding_mode]) {
                    return mapperFS[backup.funding_mode](backup);
                }
            }

            var models = this.models;

            this.venmoUser = models.venmo.username || '@' + models.venmo.first_name + '-' + models.venmo.last_name;
            this.showAmt = determineShowAmt();

            this.defaultFs = getPlanList();
            this.backupFs = getBackup();
        }
    }
});


_venmoModels.$VenmoOnboardModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_pxp.$pxpCartAmt;

_squid.$Component;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-venmo-components/src/review-paywith-venmo/directive.js
// module id = ./components/xo-venmo-components/src/review-paywith-venmo/directive.js
// module chunks = 1